import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/Layout/Spinner';
import { formatDate } from '../../utils/formatDate';

const MySubscription = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const res = await axios.get('/api/v1/member-subscriptions/me');
        setSubscription(res.data.data);
        setLoading(false);
      } catch (err) {
        if (err.response?.status === 404) {
          // No subscription found
          setSubscription(null);
        } else {
          toast.error(err.response?.data?.error || 'Error fetching your subscription');
        }
        setLoading(false);
      }
    };

    fetchSubscription();
  }, []);

  const calculateDaysRemaining = (endDate) => {
    const end = new Date(endDate);
    const now = new Date();
    const diffTime = end - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  if (loading) {
    return <Spinner />;
  }

  if (!subscription) {
    return (
      <div className="container mt-4">
        <div className="alert alert-info">
          <h4>No Active Subscription</h4>
          <p>You don't have an active subscription. Subscribe to a plan to access premium features.</p>
          <Link to="/member/subscription-plans" className="btn btn-primary">
            View Available Plans
          </Link>
        </div>
      </div>
    );
  }

  const daysRemaining = calculateDaysRemaining(subscription.expiresAt);

  return (
    <div className="container mt-4">
      <h2 className="mb-4">My Subscription</h2>
      
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h4>{subscription.plan.name}</h4>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h5>Subscription Details</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex justify-content-between">
                  <span>Status:</span>
                  <span className={`badge ${subscription.status === 'active' ? 'bg-success' : 'bg-warning'}`}>
                    {subscription.status.charAt(0).toUpperCase() + subscription.status.slice(1)}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Start Date:</span>
                  <span>{formatDate(subscription.startDate)}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>End Date:</span>
                  <span>{formatDate(subscription.expiresAt)}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Days Remaining:</span>
                  <span>{daysRemaining}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Price Paid:</span>
                  <span>${subscription.price}</span>
                </li>
              </ul>
            </div>
            
            <div className="col-md-6">
              <h5>Plan Features</h5>
              <ul className="list-group list-group-flush">
                {subscription.plan.features.map((feature, idx) => (
                  <li key={idx} className="list-group-item">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="card-footer">
          <div className="d-flex justify-content-between">
            <Link to="/member/payment-history" className="btn btn-info">
              <i className="fas fa-history me-2"></i>
              Payment History
            </Link>
            <Link to="/member/subscription-plans" className="btn btn-primary">
              <i className="fas fa-sync-alt me-2"></i>
              Upgrade Plan
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySubscription;
